import classNames from 'classnames';
import dynamic from 'next/dynamic';
import { useState } from 'react';
import type { MapPOI } from 'shared/map/interfaces';
import styles from './LocationMap.module.css';

export type LocationProps = {
    address?: string;
    locality?: string;
    latitude?: number;
    longitude?: number;
    onMapClick?: (lng: number, lat: number) => void;
    interactive?: boolean;
};

const DynamicMap = dynamic(() => import('shared/map/ClientSideMap'), {
    loading: () => <div className="map-placeholder" />,
    ssr: false,
});

export const LocationMap = ({ address, locality, longitude, latitude, onMapClick, interactive = false }: LocationProps) => {
    // TODO REIS-4591 Switch to only address when we switch to fasaden
    const locationText = address && locality && !address.includes(locality) ? `${address}, ${locality}` : address || locality || '';

    const [location, setLocation] = useState<{ lng: number; lat: number } | null>(
        longitude != null && latitude != null ? { lng: longitude, lat: latitude } : null,
    );

    const pois: MapPOI[] = location
        ? [
              {
                  name: locationText,
                  coordinates: [location.lng, location.lat],
              },
          ]
        : [];

    return (
        <div className="flex flex-col space-y-8">
            <div data-testid="locationText">{`${locationText}`}</div>
            {longitude && latitude ? (
                <DynamicMap
                    id="object-page-map"
                    selectedPois={pois}
                    className={classNames([styles.objectPageMapContainer])}
                    disableScrollZoomUnlessFocused
                    fullscreenControl
                    onMapClick={(coords: { lng: number; lat: number }) => {
                        onMapClick?.(coords.lng, coords.lat);
                        if (interactive) {
                            setLocation({ lng: coords.lng, lat: coords.lat });
                        }
                    }}
                />
            ) : null}
        </div>
    );
};
